// extracted by mini-css-extract-plugin
export default {"cell":"customRowValueCell_cell__MYdBr"};